module.exports = __webpack_public_path__ + "img/tongzhi1.627e54f.svg";